<template>
  <v-content id="settings-content">
    <v-list subheader three-line>
      <template>
        <v-subheader class="headline settings-subheader-view">一般</v-subheader>
        <v-list-item @click=";">
          <v-list-item-content>
            <v-list-item-title class="title">通知時間設定(分)</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-select :items="minutesOptions" :value="notifyMinutes" @change="onMinuteSelect"></v-select>
          </v-list-item-action>
        </v-list-item>
        <v-list-item @click=";">
          <v-list-item-content>
            <v-list-item-title class="title">自動リロード</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-switch v-model="canReload"></v-switch>
          </v-list-item-action>
        </v-list-item>
        <v-list-item @click=";" :disabled="!canReload">
          <v-list-item-content>
            <v-list-item-title class="title">リロード間隔</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-select :items="minutesOptions" :value="reloadMinutes" @change="onReloadMinuteSelect"></v-select>
          </v-list-item-action>
        </v-list-item>
        <!-- <router-link ripple class="link-tile" :to="{name: 'notification_setting'}">
          <v-list-item :style="{'background-color': 'white'}" @click="">
            <v-list-item-content>
              <v-list-item-title>通知設定</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link> -->
      </template>
    </v-list>
  </v-content>
</template>

<style scoped>
#settings-content {
  padding-top: 0px !important;
  padding-left: 0px !important;
}

.settings-subheader-view {
  background-color: #314B6E;
  color: #FFFFFF !important;
  font-weight: bold !important;
}

.link-tile {
  color: #000000 !important;
  font-size: 24px !important;
  font-weight: bold !important;
  text-decoration: none !important;
}


</style>

<script>
import store from '@/util/store.js'

  export default {
    data: () => ({
      minutesOptions: [...Array(25).keys()].map(i => i * 5)
    }),

    props: {
    },

    created() {
      this.initialize()
    },

    mounted() {
    },

    computed: {
      notifyMinutes: {
        get(){
          return store.state.notifyMinutes;
        },
        set(value) {
          store.commit('setNotifyMinutes', value);
        }
      },
      canReload: {
        get() {
          return store.state.canReload;
        },
        set(value) {
          store.commit('setCanReload', value);
        }
      },
      reloadMinutes: {
        get() {
          return store.state.reloadMinutes;
        },
        set(value) {
          store.commit('setReloadMinutes', value);
        }
      }
    },

    methods: {
      initialize: function() {
      },
      onMinuteSelect: function(value) {
        this.notifyMinutes = value;
      },
      onReloadMinuteSelect: function(value) {
        this.reloadMinutes = value;
      }
    },

  }
</script>
